import { css } from "styled-components"
import { darken, mix } from "polished"

export const fieldStyles = css`
  border: 2px solid white;
  border-radius: 0.5rem;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  width: 100%;
  box-sizing: border-box;
  display: block;
  appearance: none;
  background-image: none;
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: none;
  outline: none;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};

  &::-webkit-datetime-edit {
    line-height: 1;
    padding: 0;
    margin-bottom: -2px;
  }

  ${({ invalid, theme }) =>
    !!invalid &&
    css`
      border-color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
      background-color: ${mix(0.8, "#fff", theme.colors.danger)};
      color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
    `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      background-color: #fff;
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      height: 3rem;
      padding: 0 1rem;

      ${(props) =>
        props.showValidation &&
        css`
          &:focus {
            border-color: ${({ theme }) => theme.colors.brand};
          }
        `}

      ${({ invalid, theme }) =>
        !!invalid &&
        css`
          border-color: ${theme.colors.danger};
          background-color: ${mix(0.95, "#fff", theme.colors.danger)};
        `}

      &:disabled, &[disabled] {
        background-color: #f2f2f2;
        border-color: #e6e6e6;
        color: #999999;
      }

      &:focus {
        border-color: ${(props) => props.theme.colors.primary};
      }

      &[readonly] {
        background-color: rgba(221, 221, 221, 1);
        border-color: rgba(221, 221, 221, 1);
        color: #000;
      }
    `}
`
